import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { resetPassword } from '../services/api';
import Button from '../components/Button';
import Input from '../components/Input';
import { t } from '../i18n';
import './AuthPages.css';

const ResetPasswordPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [token, setToken] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const tokenParam = searchParams.get('token');
    if (tokenParam) {
      setToken(tokenParam);
    } else {
      setError(t('reset.error.invalidLink'));
    }
  }, [searchParams]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (newPassword !== confirmPassword) {
      setError(t('reset.error.passwordsMismatch'));
      return;
    }

    if (newPassword.length < 6) {
      setError(t('reset.error.passwordMin'));
      return;
    }

    if (!token) {
      setError(t('reset.error.invalidToken'));
      return;
    }

    setLoading(true);

    try {
      await resetPassword(token, newPassword);
      setSuccess(true);
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } catch (err: any) {
      setError(t('reset.error.generic'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-header">
          <img src="/logo.webp" alt="X-periences" className="auth-logo" />
          <h1 className="auth-title">{t('reset.title')}</h1>
          <p className="auth-subtitle">{t('reset.subtitle')}</p>
        </div>

        {!success ? (
          <form onSubmit={handleSubmit} className="auth-form">
            {error && <div className="auth-error">{error}</div>}
            
            <Input
              label={t('reset.newPassword')}
              type="password"
              placeholder={t('register.passwordPlaceholder')}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              minLength={6}
            />

            <Input
              label={t('reset.confirmPassword')}
              type="password"
              placeholder={t('reset.confirmPlaceholder')}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />

            <Button type="submit" fullWidth loading={loading} disabled={!token}>
              {t('reset.submit')}
            </Button>
          </form>
        ) : (
          <div className="auth-form">
            <div className="form-success">
              {t('reset.success')}
            </div>
          </div>
        )}

        <div className="auth-footer">
          <Link to="/login" className="auth-link">{t('common.backToLogin')}</Link>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
